import { CustomPricingType } from './pricingType';

const toCamelCase = (str: string) => {
    return str
      .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
      .replace(/^[^a-zA-Z]+/, "");
  };

function determineValueType(defaultValue: any) {
if (typeof defaultValue === 'string') {
    if (defaultValue.includes('$')) {
    return '$';
    } else if (defaultValue.includes('%')) {
    return '%';
    }
}
return '';
}

function cleanUpDefaultValue(defaultValue: any) {
if (typeof defaultValue === 'string') {
    const numbers = defaultValue.match(/[0-9.]+/g);
    if (numbers && numbers.length > 0) {
    return numbers[0];
    }
    return '';
}
return defaultValue;
}

const mapFields = (arr : any) => {
    return arr.map((item: any) => ({
      defaultValue: cleanUpDefaultValue(item.defaultValue),
      category: item.category.replace("Fee Information / ", ""),
      name: item.field,
      camelCaseName: toCamelCase(item.field),
      hidden: false,
      disabled: item.disabled === true,
      valueType: determineValueType(item.defaultValue),
      camelCaseCategory: toCamelCase(item.category),
      inputName: `${toCamelCase(item.category)}-${toCamelCase(item.field)}`,
      order: item.order,
      minValue: item.minValue,
      maxValue: item.maxValue,
    }));
  }

let flatFields = mapFields([
    { field: "Credit Card Discount Rate", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "3.85%", order: 2 },
    { field: "Offline-Debit Discount Rate", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "3.85%", order: 1 },
    { field: "Discount Rate", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "3.85%", order: 3 },
    { field: "Debit Access Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$0.00", order: 0 },
    { field: "Debit Card Tran Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$0.35", order: 5 },
    { field: "Network Fee Plus", category: "Fee Information / Miscellaneous Fees", defaultValue: "0", order: 0 },
    { field: "Regulatory Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$4.95", order: 7 },
    { field: "ESP Monthly Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$0.00", order: 0 },
    { field: "PCI Non-Action Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$59.95", order: 9 },
    { field: "Annual Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$99.95", order: 10 },
    { field: "Online Access Fee (per month)", category: "Fee Information / Monthly Fees", defaultValue: "$0.00", order: 0 },
    { field: "Customer Service / Statement Fee", category: "Fee Information / Monthly Fees", defaultValue: "$9.95", order: 6 },
    { field: "Visa/MC/Disc Tran Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.00", order: 4 },
    { field: "AVS Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.00", order: 0 },
    { field: "Batch Header Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.30", order: 8 },
    { field: "Gateway Setup Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.00", maxValue: "50.00", order: 12 },
    { field: "Gateway Setup Fee Quantity", category: "Fee Information / Equipment Fees", defaultValue: "0", minValue: "0", maxValue: "5", order: 13 },
    { field: "Gateway Access Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.00", maxValue: "50.00", order: 14 },
    { field: "Gateway Monthly Access Fee Quantity", category: "Fee Information / Equipment Fees", defaultValue: "0", minValue: "0", maxValue: "5", order: 15 },
    { field: "Gateway Tran Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.000", maxValue: "0.500", order: 16 },
  ]);

  let flatHiddenFields = mapFields([
    { field: "ACH Return Item Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$35.00", order: 0 },
    { field: "ACH Change Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$10.00", order: 0 },
    { field: "Security Research Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$25.00", order: 0 },
    // became visible
    /*
    { field: "Early Termination Fee - Year 1", category: "Fee Information / Miscellaneous Fees", defaultValue: "$350.00", order: 0 },
    { field: "Early Termination Fee - Year 2", category: "Fee Information / Miscellaneous Fees", defaultValue: "$250.00", order: 0 },
    { field: "Early Termination Fee - Year 3", category: "Fee Information / Miscellaneous Fees", defaultValue: "$250.00", order: 0 },
     */
    { field: "Retrieval Request Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$15.00", order: 0 },
    { field: "Chargeback Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$25.00", order: 0 },
    { field: "Monthly Minimum Discount Fee", category: "Fee Information / Monthly Fees", defaultValue: "$25.00", order: 0 },
    { field: "Voice Auth Fee", category: "Fee Information / Processing Fees", defaultValue: "$2.00", order: 0 },

    { field: "Other Item Fee", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "$0.00", order: 0 },
    { field: "System Processing Fee", category: "Fee Information / American Express Opt Blue", defaultValue: "0", order: 0 },
    { field: "Other Item Fee", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "$0.00", order: 0 },
    { field: "Regulatory Non-Compliance Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "30", order: 0 },
    { field: "Interchange Clearing Fee", category: "Fee Information / Processing Fees", defaultValue: "0", order: 0 },

    { field: "Amex Direct Tran Fee", category: "Fee Information / Processing Fees", defaultValue: "0.00", order: 0 },
  ]);

  let tierFields = mapFields([
    { field: "Qualified Fee", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "1.69%", order: 4 },
    { field: "Mid-Qualified Transaction Fee", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "$0.10", order: 14 },
    { field: "Non-Qualified Transaction Fee", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "$0.10", order: 15 },
    { field: "Mid-Qualified Fee: Qual+", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "2%", order: 5 },
    { field: "Non-Qualified Fee: Qual+", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "2.75%", order: 6 },
    { field: "Qualified Fee", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "1.69%", order: 1 },
    { field: "Mid-Qualified Transaction Fee", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "$0.10", order: 12 },
    { field: "Non-Qualified Transaction Fee", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "$0.10", order: 13 },
    { field: "Non-Qualified Fee: Qual+", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "2.75%", order: 3 },
    { field: "Mid-Qualified Fee: Qual+", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "2%", order: 2 },
    { field: "System Processing Fee", category: "Fee Information / American Express Opt Blue", defaultValue: "0.70%", order: 10 },
    { field: "Qualified Discount Fee", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "1.69%", order: 7 },
    { field: "Mid-Qualified Transaction Fee", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "$0.10", order: 16 },
    { field: "Non-Qualified Transaction Fee", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "$0.10", order: 17 },
    { field: "Mid-Qualified Fee: Qual+", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "2%", order: 8 },
    { field: "Non-Qualified Fee: Qual+", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "2.75%", order: 9 },
    { field: "Interchange Clearing Fee", category: "Fee Information / Processing Fees", defaultValue: "0.10%", order: 0 },
    { field: "Debit Card Tran Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$0.35", order: 18 },
    { field: "Amex Direct Tran Fee", category: "Fee Information / Processing Fees", defaultValue: "0.10", minValue: "0.000", maxValue: "0.990", order: 17.5 },
    { field: "Regulatory Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$4.95", order: 20 },
    { field: "PCI Non-Action Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$59.95", order: 22 },
    { field: "Annual Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$99.95", order: 23 },
    { field: "Customer Service / Statement Fee", category: "Fee Information / Monthly Fees", defaultValue: "$9.95", order: 19 },
    { field: "Visa/MC/Disc Tran Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.20", order: 11 },
    { field: "Batch Header Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.30", order: 21 },
    { field: "Gateway Setup Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.00", maxValue: "50.00", order: 24 },
    { field: "Gateway Setup Fee Quantity", category: "Fee Information / Equipment Fees", defaultValue: "0", minValue: "0", maxValue: "5", order: 25 },
    { field: "Gateway Access Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.00", maxValue: "50.00", order: 26 },
    { field: "Gateway Monthly Access Fee Quantity", category: "Fee Information / Equipment Fees", defaultValue: "0", minValue: "0", maxValue: "5", order: 27 },
    { field: "Gateway Tran Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.000", maxValue: "0.500", order: 28 },
  ]);

  let tierHiddenFields = mapFields([
    { field: "Other Item Fee", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "$0.00", order: 0 },
    { field: "Other Item Fee", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "$0.00", order: 0 },
    { field: "Other Item Fee", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "$0.00", order: 0 },
    { field: "Chargeback Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$25.00", order: 0 },
    { field: "Monthly Minimum Discount Fee", category: "Fee Information / Monthly Fees", defaultValue: "$25.00", order: 0 },
    { field: "AVS Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.05", order: 0 },
    { field: "Online Access Fee (per month)", category: "Fee Information / Miscellaneous Fees", defaultValue: "0", order: 0 },
    { field: "MasterCard Location Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "1.25", order: 0 },

    { field: "Voice Auth Fee", category: "Fee Information / Processing Fees", defaultValue: "$2", order: 0 },
    { field: "ACH Return Item Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$35", order: 0 },
    { field: "ACH Change Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$10", order: 0 },
    { field: "Security Research Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$25", order: 0 },
    { field: "Regulatory Non-Compliance Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "30", order: 0 },
    // became visible
    /*
    { field: "Early Termination Fee - Year 1", category: "Fee Information / Miscellaneous Fees", defaultValue: "$350.00", order: 0 },
    { field: "Early Termination Fee - Year 2", category: "Fee Information / Miscellaneous Fees", defaultValue: "$250.00", order: 0 },
    { field: "Early Termination Fee - Year 3", category: "Fee Information / Miscellaneous Fees", defaultValue: "$250.00", order: 0 },
     */

    { field: "Retrieval Request Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$15.00", order: 0 },

    // IC+ block, shown grayed-out and zeroed while a 3-Tier application is active (John's Option 3).
    // Order values are a dedicated range (200+) so they don't collide with or require renumbering
    // any existing field above.
    { field: "Offline-Debit Additional Basis Point", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "0.00%", order: 200, disabled: true },
    { field: "Credit Additional Basis Point", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "0.00%", order: 201, disabled: true },
    { field: "Credit Other Item Fee", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "0.00%", order: 202, disabled: true },
    { field: "Offline-Debit Other Item Fee", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "0.00%", order: 203, disabled: true },
    { field: "Pass-Through Pricing Plus", category: "Fee Information / Amex Interchange Pass-Through Rates", defaultValue: "0.00%", order: 204, disabled: true },
    { field: "Other Item Fee", category: "Fee Information / Amex Interchange Pass-Through Rates", defaultValue: "0.00%", order: 205, disabled: true },
  ]);

  let icFields = mapFields([
    { field: "System Processing Fee", category: "Fee Information / American Express Opt Blue", defaultValue: "0.00%", order: 0 },
    { field: "Pass-Through Pricing Plus", category: "Fee Information / Amex Interchange Pass-Through Rates", defaultValue: "1.00%", order: 3 },
    { field: "Offline-Debit Additional Basis Point", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "1.00%", order: 1 },
    { field: "Credit Additional Basis Point", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "1.00%", order: 2 },
    { field: "Interchange Clearing Fee", category: "Fee Information / Processing Fees", defaultValue: "0.10%", order: 0 },
    { field: "Debit Card Tran Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$0.35", order: 5 },
    { field: "Amex Direct Tran Fee", category: "Fee Information / Processing Fees", defaultValue: "0.10", minValue: "0.000", maxValue: "0.990", order: 4.5 },
    { field: "Regulatory Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$4.95", order: 7 },
    { field: "PCI Non-Action Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$59.95", order: 9 },
    { field: "Annual Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$99.95", order: 10 },
    { field: "Customer Service / Statement Fee", category: "Fee Information / Monthly Fees", defaultValue: "$9.95", order: 6 },
    { field: "Visa/MC/Disc Tran Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.20", order: 4 },
    { field: "Batch Header Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.30", order: 8 },
    { field: "Other Item Fee", category: "Fee Information / Amex Interchange Pass-Through Rates", defaultValue: "0.00%", order: 3 },
    { field: "Credit Other Item Fee", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "0.00%", order: 3 },
    { field: "Offline-Debit Other Item Fee", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "0.00%", order: 3 },
    { field: "Gateway Setup Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.00", maxValue: "50.00", order: 11 },
    { field: "Gateway Setup Fee Quantity", category: "Fee Information / Equipment Fees", defaultValue: "0", minValue: "0", maxValue: "5", order: 12 },
    { field: "Gateway Access Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.00", maxValue: "50.00", order: 13 },
    { field: "Gateway Monthly Access Fee Quantity", category: "Fee Information / Equipment Fees", defaultValue: "0", minValue: "0", maxValue: "5", order: 14 },
    { field: "Gateway Tran Fee", category: "Fee Information / Equipment Fees", defaultValue: "0.00", minValue: "0.000", maxValue: "0.500", order: 15 },
  ]);

  let icHiddenFields = mapFields([
    // became visible
    /*
    { field: "Other Item Fee", category: "Fee Information / Amex Interchange Pass-Through Rates", defaultValue: "$0.00", order: 0 },
    { field: "Credit Other Item Fee", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "$0.00", order: 0 },
    { field: "Offline-Debit Other Item Fee", category: "Fee Information / Interchange Pass-Through Rates", defaultValue: "$0.00", order: 0 },
     */
    { field: "Chargeback Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$25.00", order: 0 },
    { field: "Monthly Minimum Discount Fee", category: "Fee Information / Monthly Fees", defaultValue: "$25.00", order: 0 },
    { field: "AVS Fee", category: "Fee Information / Processing Fees", defaultValue: "$0.05", order: 0 },
    { field: "Online Access Fee (per month)", category: "Fee Information / Miscellaneous Fees", defaultValue: "0", order: 0 },
    { field: "MasterCard Location Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "1.25", order: 0 },
    { field: "Retrieval Request Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$15.00", order: 0 },
    { field: "Voice Auth Fee", category: "Fee Information / Processing Fees", defaultValue: "$2.00", order: 0 },
    { field: "ACH Return Item Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$35.00", order: 0 },
    { field: "ACH Change Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$10", order: 0 },
    { field: "Security Research Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "$25.00", order: 0 },
    { field: "Regulatory Non-Compliance Fee", category: "Fee Information / Miscellaneous Fees", defaultValue: "30", order: 0 },
    // became visible
    /*
    { field: "Early Termination Fee - Year 1", category: "Fee Information / Miscellaneous Fees", defaultValue: "$350.00", order: 0 },
    { field: "Early Termination Fee - Year 2", category: "Fee Information / Miscellaneous Fees", defaultValue: "$250.00", order: 0 },
    { field: "Early Termination Fee - Year 3", category: "Fee Information / Miscellaneous Fees", defaultValue: "$250.00", order: 0 },
     */

    // 3-Tier block, shown grayed-out and zeroed while an IC+ application is active (John's Option 3).
    // The package still requires these fields to be present and within range even though, under
    // Variant A, IC+ now sends Amex/MC/Visa/Disc Pricing Type = Interchange Passthru, so they are
    // not the live rate. Qualified Fee fields use the package minimum instead of zero (Paysafe
    // rejects values below minimum); everything else can be zero. Order values are a dedicated
    // range (100+) so they don't collide with or require renumbering any existing field above.
    { field: "Qualified Fee", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "0.5%", order: 100, disabled: true },
    { field: "Mid-Qualified Transaction Fee", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "$0", order: 101, disabled: true },
    { field: "Non-Qualified Transaction Fee", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "$0", order: 102, disabled: true },
    { field: "Mid-Qualified Fee: Qual+", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "0%", order: 103, disabled: true },
    { field: "Non-Qualified Fee: Qual+", category: "Fee Information / 3-Tier Credit Card Discount Fees", defaultValue: "0%", order: 104, disabled: true },
    { field: "Qualified Fee", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "0.25%", order: 105, disabled: true },
    { field: "Mid-Qualified Transaction Fee", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "$0", order: 106, disabled: true },
    { field: "Non-Qualified Transaction Fee", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "$0", order: 107, disabled: true },
    { field: "Mid-Qualified Fee: Qual+", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "0%", order: 108, disabled: true },
    { field: "Non-Qualified Fee: Qual+", category: "Fee Information / 3-Tier Offline-Debit Discount Fees", defaultValue: "0%", order: 109, disabled: true },
    { field: "Qualified Discount Fee", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "0.5%", order: 110, disabled: true },
    { field: "Mid-Qualified Transaction Fee", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "$0", order: 111, disabled: true },
    { field: "Non-Qualified Transaction Fee", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "$0", order: 112, disabled: true },
    { field: "Mid-Qualified Fee: Qual+", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "0%", order: 113, disabled: true },
    { field: "Non-Qualified Fee: Qual+", category: "Fee Information / Amex 3-Tier Rates", defaultValue: "0%", order: 114, disabled: true },
  ]);

  let commonFields = mapFields([
    { field: "Retail Swiped/EMV", category: "Business Information / Processing Breakdown", defaultValue: "95%", order: 1 },
    { field: "Retail Keyed %", category: "Business Information / Processing Breakdown", defaultValue: "5%", order: 2 },
    { field: "Internet %", category: "Business Information / Processing Breakdown", defaultValue: "0%", order: 3 },
    { field: "MOTO %", category: "Business Information / Processing Breakdown", defaultValue: "0%", order: 4 },
  ]);

  const fields = {
    [CustomPricingType.Flat]: flatFields,
    [CustomPricingType.ThreeTier]: [...tierFields, ...tierHiddenFields.filter((f: any) => f.disabled)],
    [CustomPricingType.ICPlus]: [...icFields, ...icHiddenFields.filter((f: any) => f.disabled)],
  };

  const getFields = (fieldType: CustomPricingType, customCategory: any) => {
    if (fieldType) {
      const fieldsByType = fields[fieldType];
      return fieldsByType
        .filter((f: { order: number; }) => f.order >= customCategory.min && f.order <= customCategory.max)
        .sort((a: { order: number; }, b: { order: number; }) => a.order - b.order);
    }
    else {
      return [];
    }
  }

  const customCategories = {
    [CustomPricingType.Flat]: [
      {
        name: 'Rates',
        min: 1,
        max: 4,
        order: 1,
      },
      {
        name: 'Trans Fees',
        min: 5,
        max: 6,
        order: 2,
      },
      {
        name: 'Misc. Fees',
        min: 7,
        max: 11,
        order: 3,
      },
      {
        name: 'Gateway Fees',
        min: 12,
        max: 16,
        order: 4,
      },
      {
        name: 'Other',
        min: 0,
        max: 0,
        order: 5,
      },
    ],
    [CustomPricingType.ThreeTier]: [
      {
        name: 'Debit Rates',
        min: 1,
        max: 3,
        order: 1,
      },
      {
        name: 'Credit Rates',
        min: 4,
        max: 6,
        order: 2,
      },
      {
        name: 'Amex Rates',
        min: 7,
        max: 10,
        order: 3,
      },
      {
        name: 'Trans Fees',
        min: 11,
        max: 18,
        order: 4,
      },
      {
        name: 'Misc. Fees',
        min: 19,
        max: 23,
        order: 5,
      },
      {
        name: 'Gateway Fees',
        min: 24,
        max: 28,
        order: 6,
      },
      {
        name: 'Interchange Rates (not used)',
        min: 200,
        max: 205,
        order: 7,
      },
      {
        name: 'Other',
        min: 0,
        max: 0,
        order: 8,
      },
    ],
    [CustomPricingType.ICPlus]: [
      {
        name: 'Rates',
        min: 1,
        max: 3,
        order: 1,
      },
      {
        name: 'Trans Fees',
        min: 4,
        max: 5,
        order: 2,
      },
      {
        name: 'Misc. Fees',
        min: 6,
        max: 10,
        order: 3,
      },
      {
        name: 'Gateway Fees',
        min: 11,
        max: 15,
        order: 4,
      },
      {
        name: '3-Tier Rates (not used)',
        min: 100,
        max: 114,
        order: 5,
      },
      {
        name: 'Other',
        min: 0,
        max: 0,
        order: 6,
      },
    ]
  };

  const setHiddenPricingFields = (application: any) => {
    if (!application.customPricing) {
      application.customPricing = {};
    } else {
      const allHiddenFields = [...flatHiddenFields, ...tierHiddenFields, ...icHiddenFields];
      const excludeFields = fields[application.customPricingType as CustomPricingType].map((f: { inputName: string; }) => f.inputName);

      allHiddenFields
        .filter(hiddenField => !excludeFields.includes(hiddenField.inputName))
        .forEach((field: any) => {
          delete application.customPricing[field.inputName];
        });
    }

    if (application.customPricingType === CustomPricingType.Flat) {
        flatHiddenFields.forEach((field: any) => {
            application.customPricing[field.inputName] = field.defaultValue;
        });
    }
    if (application.customPricingType === CustomPricingType.ThreeTier) {
      tierHiddenFields.forEach((field: any) => {
          application.customPricing[field.inputName] = field.defaultValue;
      });
    }
    if (application.customPricingType === CustomPricingType.ICPlus) {
      icHiddenFields.forEach((field: any) => {
          application.customPricing[field.inputName] = field.defaultValue;
      });
    }
  }

  export default {flatFields, icFields, tierFields, commonFields, setHiddenPricingFields, customCategories, getFields}
